"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6561],{

/***/ 16561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97133);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_gen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6555);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    visibility: visible;\n    opacity: 1;\n    display: flex;\n  }\n  100% {\n    visibility: hidden;\n    opacity: 0;\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var fadeOut = (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var style = {
    container: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:fixed;z-index:3;background-color:#fcefe6;padding:16px 20px;border-radius:10px;box-shadow:0px 2px 5px rgba(0,0,0,0.07);visibility:visible;display:flex;opacity:1;@media (max-width:767px){margin-left:1rem;margin-right:1rem;width:calc(100% - 2rem);}@media (min-width:768px){right:24px;width:calc(100% - 48px);max-width:560px;}"),
    containerHidden: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("animation:", fadeOut, " 0.3s linear;animation-fill-mode:forwards;"),
    containerOffset: function(offset) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("top:", offset + 18, "px;");
    },
    icon: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("width:24px;height:24px;flex:0 0 24px;line-height:21px;border-radius:50%;margin-right:16px;background-color:#dc5800;color:#ffffff;text-align:center;font-weight:700;margin-top:4px;"),
    header: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("display:flex;"),
    heading: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("font-size:20px;line-height:28px;margin:0;flex:1 1 auto;"),
    btnDismiss: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("flex:0 0 0%;font-size:14px;line-height:20px;padding-left:5px;padding-right:5px;transform:translateX(5px);&:focus{outline:none;}"),
    text: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("flex:1 1 auto;max-width:calc(100% - 40px);color:#444444;font-size:1rem;line-height:1.5;p{margin:4px 0 0;}")
};
var ProductDescriptionAlert = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, text = param.text, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, _dismissHandler = param.dismissHandler, dismissHandler = _dismissHandler === void 0 ? function() {} : _dismissHandler, _timeout = param.timeout, timeout = _timeout === void 0 ? 0 : _timeout;
    var dismissTimer = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(setTimeout(function() {
        return null;
    }, 0));
    var container = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), offset = ref[0], updateOffset = ref[1];
    var updatePopupPlacement = function() {
        var mainArr = document.getElementsByTagName("main");
        if (mainArr.length) {
            var main = mainArr[0];
            var previousElementSibling = main.previousElementSibling;
            if (previousElementSibling) {
                updateOffset(previousElementSibling.clientHeight);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (timeout && dismissHandler) {
            dismissTimer.current = setTimeout(dismissHandler, timeout);
        }
        return function() {
            clearTimeout(dismissTimer.current);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if ((container === null || container === void 0 ? void 0 : container.current) && "object" !== "undefined") {
            updatePopupPlacement();
            window.addEventListener("resize", updatePopupPlacement);
        }
    }, [
        container
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__.cx)([
            style.container,
            isVisible ? "" : style.containerHidden,
            style.containerOffset(offset)
        ]),
        ref: container,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                className: style.icon,
                children: "!"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: style.text,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                        className: style.header,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
                                className: style.heading,
                                children: heading
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
                                type: "button",
                                className: style.btnDismiss,
                                onClick: dismissHandler,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__.FontAwesomeIcon, {
                                    icon: [
                                        "far",
                                        "times"
                                    ]
                                })
                            })
                        ]
                    }),
                    text ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_prezzee_ribbon_src_components_personal_RichText_RichText_gen__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                        children: text
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProductDescriptionAlert);


/***/ }),

/***/ 78078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE

function RichText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        className: className$1,
        dangerouslySetInnerHTML: {
            __html: props.children
        }
    });
}
var make = RichText;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 6555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _RichText_bs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78078);
/* TypeScript file generated from RichText.res by genType. */ /* eslint-disable import/first */ // @ts-ignore: Implicit any on import

var RichTextBS = _RichText_bs__WEBPACK_IMPORTED_MODULE_0__;
var make = RichTextBS.make;


/***/ })

}]);